module.exports = __webpack_public_path__ + "img/image_slide2_1.d935016e.png";